<mat-icon matTooltip="{{ 'GridTable.Filter.FilterDate' | translate }}" [matMenuTriggerFor]="menu">filter_alt</mat-icon>
<mat-menu #menu="matMenu" class="p-3">
    <form [formGroup]="filterForm" (click)="$event.stopPropagation();">
        <div class="col">
            <mat-form-field class="w-100">
              <mat-label>{{ 'GridTable.Filter.FilterType' | translate }}</mat-label>
                <mat-select [formControl]="filterTypeControl" [value]="filterTypeControl"
                    (selectionChange)="onFilterChange($event)" (click)="$event.stopPropagation();">
                    <mat-option *ngFor="let option of filterOptions" [value]="option.value"
                        (click)="$event.stopPropagation();">
                        {{ option.translationKey | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </form>
    <ng-container *ngIf="this.currentFilter.value !== this.dateFilterBetween; else betweenTemplate">
        <form [formGroup]="singleDateForm" (click)="$event.stopPropagation();">
            <div class="col">
                <mat-form-field>
                  <mat-label>{{'GridTable.Filter.Date' | translate }} </mat-label>
                    <input matInput [formControl]="dateSingleDateControl" [matDatepicker]="singlePicker"
                        (click)="$event.stopPropagation();">
                    <mat-datepicker-toggle matSuffix [for]="singlePicker" (click)="$event.stopPropagation();">
                    </mat-datepicker-toggle>
                    <mat-datepicker #singlePicker startView="month" (click)="$event.stopPropagation();">
                    </mat-datepicker>
                </mat-form-field>
            </div>
        </form>
    </ng-container>
    <ng-template #betweenTemplate>
        <form [formGroup]="dateBetweenForm" (click)="$event.stopPropagation();">
            <div class="col">
                <mat-form-field>
                  <mat-label>{{'GridTable.Filter.DateFrom' | translate }} </mat-label>
                    <input matInput [formControl]="dateBetweenValueControl" [matDatepicker]="fromPicker"
                        (click)="$event.stopPropagation();">
                    <mat-datepicker-toggle matSuffix [for]="fromPicker" (click)="$event.stopPropagation();">
                    </mat-datepicker-toggle>
                    <mat-datepicker #fromPicker startView="month" (click)="$event.stopPropagation();"></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col">
                <mat-form-field>
                  <mat-label>{{'GridTable.Filter.DateTo' | translate }} </mat-label>
                    <input matInput [formControl]="dateBetweenValue2Control" [matDatepicker]="toPicker"
                        (click)="$event.stopPropagation();">
                    <mat-datepicker-toggle matSuffix [for]="toPicker" (click)="$event.stopPropagation();">
                    </mat-datepicker-toggle>
                    <mat-datepicker #toPicker startView="month" (click)="$event.stopPropagation();"></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="mt-4">
            </div>
        </form>
    </ng-template>
    <div class="col" style="display: flex; justify-content: flex-end;">
        <mat-icon matTooltip="{{ 'GridTable.Filter.Cancel' | translate }}" style="cursor: pointer;" color="primary"
            (click)="onCancel()">
            clear
        </mat-icon>
        <mat-icon matTooltip="{{ 'GridTable.Filter.ApplyFilter' | translate }}" style="cursor: pointer;" color="primary"
            (click)="onSubmit($event)">
            check
        </mat-icon>
        <mat-icon matTooltip="{{ 'GridTable.Filter.Clear' | translate }}" style="cursor: pointer;" color="primary"
            *ngIf="this.currentValue | async" (click)="onClear()">
            delete
        </mat-icon>
    </div>
</mat-menu>
